import React, { useContext, useState } from "react";
import { getMyEvents } from "../../actions/eventActions";
import { StoreContext } from "../../Context/StoreContext";
import { useWindowSize } from "../../hooks/useWindowSize";
import EventCard from "../../VibehutUI/Card/EventCard";
import Carousel from "react-multi-carousel";
import EventSubscriptionModal from "../../VibehutUI/EventSubscriptionModal";
import { carouselResponsiveConfig } from "../../utils/utils";
import { getMyInvitedEvents } from "../../services/eventService";
import globals from "../../globals";
import AllInvitedEvents from "./AllInvitedEvents";
import { Link } from "react-router-dom";

function HomeMyEvent() {
  const { state, dispatch } = useContext(StoreContext);
  const { width } = useWindowSize();
  const [openEventModal, setOpenEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [myInvitedEvents, setMyInvitedEvents] = useState([]);

  const {
    event: { myEvents },
    auth: { user },
  } = state;

  const fetchMyInvitedEvents = async () => {
    try {
      const response = await getMyInvitedEvents(user?.token);
      const invitedEvents = response.data?.events || [];
      setMyInvitedEvents(invitedEvents);
    } catch (error) {
      console.log(error);
    }
  };

  const OpenInvitedEventsModal = () => {
    globals.showModal(
      "Invited Events",
      <AllInvitedEvents events={myInvitedEvents} />,
    );
  };

  React.useEffect(() => {
    if (user?.token) {
      getMyEvents(user.token, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (user?.token) {
      fetchMyInvitedEvents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myEvents]);

  return (
    <div>
      {myEvents?.length > 0 ? (
        <div className="flex flex-col pt-8 space-x-0">
          <div className="w-full flex justify-between px-2 items-center">
            <p className="select-none font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite ">
              My Upcoming Events
            </p>
            <div className="flex items-center gap-2">
              {myInvitedEvents.length > 0 && (
                <p className="select-none font-bold text-xl text-darkGray">
                  You've Been Invited
                  <span
                    onClick={OpenInvitedEventsModal}
                    className="cursor-pointer"
                  >
                    {" "}
                    {`[See ${myInvitedEvents.length} ${
                      myInvitedEvents.length === 1 ? "Event" : "Events"
                    }]`}
                  </span>
                </p>
              )}
              <Link
                to={`/events?type=my-events`}
                className="select-none font-bold text-xl text-primary"
              >
                See All
              </Link>
            </div>
          </div>
          <div className="hidden w-full md:grid md:grid-cols-2 lg:grid-cols-2 3xl:grid-cols-3 grid-cols-1 gap-6 py-6 px-2">
            {myEvents.slice(0, width > 1600 ? 3 : 2).map((event) => (
              <EventCard
                event={event}
                key={event?._id}
                showRoomLink
                enableTopMargin={false}
                showCreated={true}
                showEventTimeLine={true}
              />
            ))}
          </div>
          <div className="md:hidden block py-6">
            <Carousel
              responsive={carouselResponsiveConfig}
              renderButtonGroupOutside={true}
              itemClass="px-2.5"
              arrows={false}
              shouldResetAutoplay={false}
            >
              {myEvents.map((event) => (
                <EventCard
                  event={event}
                  key={event?._id}
                  showRoomLink
                  enableTopMargin={false}
                  showCreated={true}
                  showEventTimeLine={true}
                />
              ))}
            </Carousel>
          </div>
        </div>
      ) : undefined}
      <EventSubscriptionModal
        isOpen={openEventModal}
        setIsOpen={setOpenEventModal}
        amount={selectedEvent?.price}
        event={selectedEvent}
        eventCreator={selectedEvent?.owner}
        eventName={selectedEvent?.title}
      />
    </div>
  );
}

export default HomeMyEvent;
